"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BodyContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _Body = require("b2b-components/core/components/Gallery/Gallery/Body/Body");
var _usePrevious = require("b2b-components/hooks/usePrevious");
var _useScript = require("b2b-components/hooks/useScript");
var _sumItemsFromProps = require("../../utils/sumItemsFromProps");
var _ = require("../");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BodyContainer = _ref => {
  let {
    maxThumbnailCount = 0,
    ...originalProps
  } = _ref;
  const {
    currentItemType,
    image360,
    images,
    isMobile,
    isPreview,
    onItemChange,
    totalItemCount,
    text,
    videos
  } = originalProps;
  const prevItemType = (0, _usePrevious.usePrevious)(currentItemType);
  const itemCount = (0, _sumItemsFromProps.sumItemsFromProps)({
    image360: image360 || null,
    images: images || null,
    videos: videos || null
  });
  const moreItemCount = itemCount === totalItemCount || maxThumbnailCount >= totalItemCount || !isPreview ? 0 : totalItemCount - maxThumbnailCount;
  const handleThumbnailClick = itemIndex => e => {
    e.preventDefault();
    onItemChange?.(itemIndex);
  };
  (0, _useScript.useScript)('/assets/magiczoom.js');
  (0, _useScript.useScript)('/assets/magic360.js');
  (0, _react.useEffect)(() => {
    if (!isPreview) {
      window.mzOptions = {
        onZoomIn: () => {
          window.mzIsZoomed = true;
        },
        onZoomOut: () => {
          window.mzIsZoomed = false;
        }
      };
      window.Magic360Lang = {
        'hint-text': text.spinHint,
        'mobile-hint-text': text.spinHintMobile
      };
      if (prevItemType !== currentItemType && currentItemType === _.GALLERY_ITEM_TYPE.image360) {
        window.Magic360?.start?.();
      }
    }
  }, [
  // it seems that a few deps below are not neccessary, but they are
  // otherwise there is a bug with mobileMenu
  currentItemType, isMobile, isPreview, prevItemType]);
  return /*#__PURE__*/_react.default.createElement(_Body.Body, (0, _extends2.default)({}, originalProps, {
    moreItemCount: moreItemCount,
    onThumbnailClick: handleThumbnailClick
  }));
};
exports.BodyContainer = BodyContainer;
//# sourceMappingURL=BodyContainer.js.map